<script>
 import 'whatwg-fetch';
 import 'promise-polyfill/src/polyfill';
 import Map from './Map.svelte';
 export let ready;

 let companies = [];
 let states = [];
 let center = null;

 // ************ TREATED FILTERS **************

 let commodities = null;
 let preservatives = null;
 let use_cats = null;
 let treated_species = null;
 let treated_seasoning = null;

 let display_commodities = false;
 let display_preservatives = false;
 let display_use_cats = false;
 let display_treated_species = false;
 let display_treated_seasoning = false;

 let selected_commodities = [];
 let selected_preservatives = [];
 let selected_use_cats = [];
 let selected_treated_species = [];
 let selected_treated_seasoning = [];

 // ************ LUMBER FILTERS **************

 let dimensions = null;
 let lengths = null;
 let grades = null;
 let treatments = null;
 let mfg_codes = null;
 let lumber_species = null;

 let display_dimensions = false;
 let display_lengths = false;
 let display_grades = false;
 let display_treatments = false;
 let display_mfg_codes = false;
 let display_lumber_species = false;

 let selected_dimensions = [];
 let selected_lengths = [];
 let selected_grades = [];
 let selected_treatments = [];
 let selected_mfg_codes = [];
 let selected_lumber_species = [];


 let search = "";
 let statecode = "";

 function getAllCompanies() {
   fetch('/api/product-locator/companies')
     .then(async function(response) {
       var data = await response.json();

       companies = data.companies;
       center = { lat: parseFloat(data.center[0]),
                  lng: parseFloat(data.center[1])
                };

       states = data.states;

       // ************ TREATED FILTERS **************
       commodities = data.commodities;
       preservatives = data.preservatives
       use_cats = data.use_cats
       treated_species = data.treated_species
       treated_seasoning = data.treated_seasoning

       // ************ LUMBER FILTERS **************
       dimensions = data.dimensions;
       lengths = data.lengths
       grades = data.grades
       treatments = data.treatments
       mfg_codes = data.mfg_codes
       lumber_species = data.lumber_species
     });
 }

 function getFilteredProducts() {
   var url = '/api/product-locator/results?';

   if ( selected_preservatives.length > 0 ) {
     url += 'preservatives=' + selected_preservatives.join() + '&';
   }
   if ( selected_use_cats.length > 0 ) {
     url += 'use_cats=' + selected_use_cats.join() + '&';
   }
   if ( selected_treated_species.length > 0 ) {
     url += 'treated_species=' + selected_treated_species.join() + '&';
   }
   if ( selected_treated_seasoning.length > 0 ) {
     url += 'treated_seasoning=' + selected_treated_seasoning.join() + '&';
   }
   if ( selected_commodities.length > 0 ) {
     url += 'commodities=' + selected_commodities.join() + '&';
   }
   if ( selected_dimensions.length > 0 ) {
     url += 'dimensions=' + selected_dimensions.join() + '&';
   }
   if ( selected_lengths.length > 0 ) {
     url += 'lengths=' + selected_lengths.join() + '&';
   }
   if ( selected_grades.length > 0 ) {
     url += 'grades=' + selected_grades.join() + '&';
   }
   if ( selected_treatments.length > 0 ) {
     url += 'treatments=' + selected_treatments.join() + '&';
   }
   if ( selected_mfg_codes.length > 0 ) {
     url += 'mfg_codes=' + selected_mfg_codes.join() + '&';
   }
   if ( selected_lumber_species.length > 0 ) {
     url += 'lumber_species=' + selected_lumber_species.join() + '&';
   }

   if ( search ) {
     url += 'search=' + search + '&';
   }
   if ( statecode ) {
     url += 'statecode=' + statecode;
   }

   fetch(url)
     .then(async function(response) {
       var data = await response.json();

       companies = data.companies;
       center = {
         lat: parseFloat(data.center[0]),
         lng: parseFloat(data.center[1])
       };
       states = data.states

       commodities = data.commodities;
       preservatives = data.preservatives
       use_cats = data.use_cats
       treated_species = data.treated_species
       treated_seasoning = data.treated_seasoning

       dimensions = data.dimensions;
       lengths = data.lengths
       grades = data.grades
       treatments = data.treatments
       mfg_codes = data.mfg_codes
       lumber_species = data.lumber_species
     });
 }

 function toggleFilter(event) {
   event.preventDefault();
   event.stopPropagation();
   var toggle = event.target.dataset.filter;

   if ( ! toggle ) {
     toggle = event.target.parentElement.dataset.filter;
   }

   if ( toggle === 'commodities' ) {
     display_commodities = ( display_commodities ? false : true );
   }
   if ( toggle === 'preservatives' ) {
     display_preservatives = ( display_preservatives ? false : true );
   }
   if ( toggle === 'use_cats' ) {
     display_use_cats = ( display_use_cats ? false : true );
   }
   if ( toggle === 'treated_species' ) {
     display_treated_species = ( display_treated_species ? false : true );
   }
   if ( toggle === 'treated_seasoning' ) {
     display_treated_seasoning = ( display_treated_seasoning ? false : true );
   }

   if ( toggle === 'dimensions' ) {
     display_dimensions = ( display_dimensions ? false : true );
   }
   if ( toggle === 'lengths' ) {
     display_lengths = ( display_lengths ? false : true );
   }
   if ( toggle === 'grades' ) {
     display_grades = ( display_grades ? false : true );
   }
   if ( toggle === 'treatments' ) {
     display_treatments = ( display_treatments ? false : true );
   }
   if ( toggle === 'mfg_codes' ) {
     display_mfg_codes = ( display_mfg_codes ? false : true );
   }
   if ( toggle === 'lumber_species' ) {
     display_lumber_species = ( display_lumber_species ? false : true );
   }

   var span = event.target.querySelector('span');

   if ( ! span ) {
     span = event.target;
   }

   span.classList.toggle('flipped');
 }

 function submitSearch(event) {
   event.preventDefault();
   getFilteredProducts();
 }

 function resetFilters() {
   search = "";
   statecode = "";

   selected_commodities = [];
   selected_preservatives = [];
   selected_use_cats = [];
   selected_treated_species = [];
   selected_treated_seasoning = [];

   selected_dimensions = [];
   selected_lengths = [];
   selected_grades = [];
   selected_treatments = [];
   selected_mfg_codes = [];
   selected_lumber_species = [];

 }

 $: {
   if ( selected_commodities.length
     || statecode.length
     || selected_preservatives.length
     || selected_use_cats.length
     || selected_treated_species.length
     || selected_treated_seasoning.length
     || selected_dimensions.length
     || selected_lengths.length
     || selected_grades.length
     || selected_treatments.length
     || selected_mfg_codes.length
     || selected_lumber_species.length
   ) {
     getFilteredProducts();
   } else {
     getAllCompanies();
   }
 }
</script>

<div class="full wrap">
<div class="left filters" >
  <form on:submit={submitSearch} class="search_container">
    <select name="statecode" bind:value={statecode} on:change={getFilteredProducts}>
      <option value="">Filter By State</option>
      {#each states as state}
        <option value={state.code}>{state.name}</option>
      {/each}
    </select>
    <input bind:value={search} type="text" name="search"
      placeholder="Search by Name, City or Plant ID">
    <button type="submit" class="primary">Search</button>
    <button on:click={resetFilters}>Reset</button>
  </form>

  <hr style="margin-right: 20px">

  <div class="filter_title"><strong>Lumber Filters</strong></div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="dimensions" href="#filter=dimensions">
      Dimensions <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_dimensions}
      <ul class="filter_list">
        {#each dimensions as item}
          <li>
            <input bind:group={selected_dimensions} type="checkbox"
                   id="dimensions_{item.id}"
                   name="dimensions" value="{item.id}">
            <label for="dimensions_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="lengths" href="#filter=lengths">
      Lengths <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_lengths}
      <ul class="filter_list">
        {#each lengths as item}
          <li>
            <input bind:group={selected_lengths} type="checkbox"
                   id="lengths_{item.id}"
                   name="lengths" value="{item.id}">
            <label for="lengths_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="grades" href="#filter=grades">
      Grades <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_grades}
      <ul class="filter_list">
        {#each grades as item}
          <li>
            <input bind:group={selected_grades} type="checkbox"
                   id="grades_{item.id}"
                   name="grades" value="{item.id}">
            <label for="grades_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="treatments" href="#filter=treatments">
      Seasoning <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_treatments}
      <ul class="filter_list">
        {#each treatments as item}
          <li>
            <input bind:group={selected_treatments} type="checkbox"
                   id="treatments_{item.id}"
                   name="treatments" value="{item.id}">
            <label for="treatments_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="lumber_species" href="#filter=lumber_species">
      Species <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_lumber_species}
      <ul class="filter_list">
        {#each lumber_species as item}
          <li>
            <input bind:group={selected_lumber_species} type="checkbox"
                   id="lumber_species_{item.id}"
                   name="lumber_species" value="{item.id}">
            <label for="lumber_species_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="mfg_codes" href="#filter=mfg_codes">
      Manufacturing Codes <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_mfg_codes}
      <ul class="filter_list">
        {#each mfg_codes as item}
          <li>
            <input bind:group={selected_mfg_codes} type="checkbox"
                   id="mfg_codes_{item.id}"
                   name="mfg_codes" value="{item.id}">
            <label for="mfg_codes_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>

  <hr style="margin-right: 20px;">

  <div class="filter_title"><strong>Treating Filters</strong></div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="preservatives" href="#filter=preservatives">
      Preservatives <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_preservatives}
      <ul class="filter_list">
        {#each preservatives as item}
          <li>
            <input bind:group={selected_preservatives} type="checkbox"
                   id="preservatives_{item.id}"
                   name="preservatives" value="{item.id}">
            <label for="preservatives_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="use_cats" href="#filter=use_cats">
      Use Categories <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_use_cats}
      <ul class="filter_list">
        {#each use_cats as item}
          <li>
            <input bind:group={selected_use_cats} type="checkbox"
                   id="use_cats_{item.id}"
                   name="use_cats" value="{item.id}">
            <label for="use_cats_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="commodities" href="#filter=commodities">
      Commodities <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_commodities}
      <ul class="filter_list">
        {#each commodities as item}
          <li>
            <input bind:group={selected_commodities} type="checkbox"
                   id="commodities_{item.id}"
                   name="commodities" value="{item.id}">
            <label for="commodities_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="treated_species" href="#filter=treated_species">
      Species <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_treated_species}
      <ul class="filter_list">
        {#each treated_species as item}
          <li>
            <input bind:group={selected_treated_species} type="checkbox"
                   id="treated_species_{item.id}"
                   name="treated_species" value="{item.id}">
            <label for="treated_species_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <div class="filter_group" >
    <a on:click={toggleFilter} class="filter" data-filter="treated_seasoning" href="#filter=treated_seasoning">
      ADAT / KDAT <span class="toggle">&#x25bc;</span>
    </a>
    {#if display_treated_seasoning}
      <ul class="filter_list">
        {#each treated_seasoning as item}
          <li>
            <input bind:group={selected_treated_seasoning} type="checkbox"
                   id="treated_seasoning_{item.id}"
                   name="treated_seasoning" value="{item.id}">
            <label for="treated_seasoning_{item.id}">{ item.name }</label>
          </li>
        {/each}
      </ul>
    {/if}
  </div>

</div>
<div class="right map-outer-wrap">
  {#if ready}
    <Map companies={companies} center={center}></Map>
  {/if}

  <hr>

  <p>
    <strong>Printable Subscriber Rosters</strong><br>
    <a target="_blank" href="/uploads/pdfs/lumber.pdf">Lumber</a><br>
    <a target="_blank" href="/uploads/pdfs/treating.pdf">Treating</a><br>
  </p>

</div>
</div>

<hr style="margin-right: 20px;">

{#if companies.length}
  <div class="companies list">
    {#each companies as company}
      <div class="company">
        <h2><a href="/buyers-guide/company/{ company.id }">{ company.name }</a></h2>
        <ul>
          {#each company.facilities as facility}
            <li><a href="/buyers-guide/{facility.code}">
              { facility.plantid } - {facility.city}, {facility.state}
            </a></li>
          {/each}
        </ul>
      </div>
    {/each}
  </div>
{:else}
  <div class="middle">
    <p style="margin-top:40px">No facilities met your criteria.</p>
  </div>
{/if}

<style>
 .filter_title {
   color: #1f5733;
 }

 .wrap.full {
   overflow: auto;
   position: relative;
   display: block;
 }

 .companies.list {
   display: grid;
   grid-template-columns: auto auto auto;
 }

 .company {
   border: 2px solid #1f5733;
   padding: 5px 10px;
   margin: 20px;
   margin-left: 0px;
 }

 .company h2 {
   font-size: 1.4rem;
   margin: 0;
 }

 .company ul {
   list-style-type: none;
 }

 .company ul li {
   margin: 0.5rem 0;
 }

 .left {
   width: 50%;
 }

 .middle {
   width: 33%;
 }

 .right {
   width: 50%;
 }

 .left, .middle, .right {
   display: inline-block;
 }

 .filters {
   padding-bottom: 30px;
   margin-bottom: 30px;
 }

 .filter_group {
   margin-top: 20px;
   margin-right: 20px;
   border: 2px solid #1f5733;
   padding: 10px 20px;
 }

 .filter_group .filter {
   font-weight: bold;
   text-decoration: none;
   font-size: 1rem;
   display: block;
 }

 .filter_group .filter .toggle {
   float: right;
 }

 .filter_group .filter_list {
   text-align: left;
   list-style-type: none;
   padding-top: 20px;
   margin-top: 10px;
   border-top: 2px solid #1f5733;
 }

 .filter_group .filter_list li {
   line-height: 1.4rem;
 }

 .filter_group .filter_list li label {
   display: inline;
 }

 .search_container {
   margin-top: 20px;
   margin-right: 20px;
   position: relative;
   display: block;
   overflow: hidden;
   width: auto;
 }

 .search_container input[type="text"] {
   border: 2px solid #1f5733;
   width: 100%;
   display: block;
 }

 .search_container input::placeholder {
   color: #555;
   opacity: 1;
 }

 .search_container button {
   transition-duration: 0.4s;
   border: none;
   padding: 15px 32px;
   text-align: center;
   text-decoration: none;
   display: inline-block;
   background-color: #e7e7e7;
   color: #1f5733;
   float: right;
   width: 48%;
 }

 .search_container button:hover {
   background-color: #c0c0c0;
 }

 .search_container button.primary {
   background-color: #1f5733;
   color: white;
   float: left;
 }

 .search_container button.primary:hover {
   background-color: #12311d;
 }

 @media (max-width: 850px) {
   .left, .right, .middle {
     width: 100%;
   }

 .companies.list {
   display: block;
 }

 }
</style>
